import React from 'react'
import { Carousel, CarouselItem } from '@shared/components/carousel'
import { Section } from '@shared/components/section'
import { interviewData } from 'screens/partners/sections/interview/data'
import { Image } from 'shared/components/image'

import styles from './style.module.scss'

export const View = () => (
	<Section>
		<div className={styles.wrapper}>
			<Carousel
				title={
					<h2 className={styles.title}>
						Берём интервью у наших партнёров <br />и рассказываем о них в блоге
					</h2>
				}
			>
				{interviewData.map(({ name, text, href, image }, i) => (
					<CarouselItem key={`listbox-${i}-${name}`}>
						<div className={styles.cardWrapper}>
							<div className={styles.card}>
								<div className={styles.cardHeader}>
									<div className={styles.imgWrapper}>
										<Image lazy className={styles.cardPhoto} name={image} />
									</div>
									<h3 className={styles.name}>{name}</h3>
								</div>
								<div className={styles.cardBody}>
									<div className={styles.cardText}>
										<h4 className={styles.cardTitle}>{text}</h4>
									</div>
									<div>
										<a
											className={styles.cardLink}
											href={href}
											target='_blank'
											rel='noopener noreferrer nofollow'
										>
											Читать интервью
										</a>
									</div>
								</div>
							</div>
						</div>
					</CarouselItem>
				))}
			</Carousel>
		</div>
	</Section>
)
